<template>
 
  <div class="user">

    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
               
        <el-form-item label="服务名称/ID">
          <el-input placeholder="请输入服务名称/ID" v-model="formInline.search">
        
          </el-input>
        </el-form-item>

        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="formInline.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        
        <el-form-item label="是否申报：" >
          <el-select size="small" v-model="formInline.is_declare" placeholder="是否申报">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="未申报" :value="0"></el-option>
            <el-option label="已申报" :value="1"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="是否审核：" >

          <el-select size="small" v-model="formInline.audit_status" placeholder="是否审核">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="未审核" :value="0"></el-option>
            <el-option label="已审核" :value="1"></el-option>
            <el-option label="未通过" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
   
        </el-form-item>

      </el-form>
    </div>


    <!-- <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加申报</el-button>
    </div> -->

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="service_info_id" label="ID"></el-table-column>
            <el-table-column prop="service.service_id" label="服务ID"></el-table-column>
            <el-table-column prop="service.name" label="服务名称"></el-table-column>
            <el-table-column prop="create_times" label="申报日期"></el-table-column>
            <el-table-column prop="service_staff_ids.length" label="申报人数"></el-table-column>
            <el-table-column prop="bank_code" label="银行类别"></el-table-column>
            <el-table-column prop="remark" label="申报情况"></el-table-column>
        
            <el-table-column prop="is_declare" label="申报情况" width="150">
              <template slot-scope="scope">
                  <div>
                    <div v-if="scope.row.is_declare == 0">
                  未申报
                </div>
                <div v-if="scope.row.is_declare == 1">
                    已申报
                </div>
      

                  </div>
              </template>

            </el-table-column>  
            
            <el-table-column prop="audit_status" label="审核情况" width="150">
              <template slot-scope="scope">
                <div>
                  <div v-if="scope.row.audit_status == 0">
                  未审核
                </div>
                <div v-if="scope.row.audit_status == 1">
                    已审核
                </div>
                <div v-if="scope.row.audit_status == 2">
                    审核未通过;原因：{{scope.row.reject_val  }}
                </div>
                </div>
              </template>

            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>

            <el-table-column prop="create_time" label="快捷申报" width="150">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.is_declare"  active-color="#13ce66" inactive-color="#ff4949" @change="isDefaultChange(scope.row)"></el-switch>
              </template>

            </el-table-column>

            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button v-if="scope.row.audit_status == 0" @click="passClick(scope.row)" type="text" size="small">审核</el-button>
                <el-button v-if="scope.row.audit_status == 0" @click="nopassClick(scope.row)" type="text" size="small">审核不通过</el-button>
                
                <el-button @click="editClick(scope.row)" type="text" size="small">处理申报</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"  :service_id="service_id"  @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :service_id="service_id" :service_info_id="service_info_id"  v-if="open_edit"   @close="closeEdit"></Edit>

  </div>

</template>

<script>
  import ServiceApi from '@/api/service.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          is_declare:-1,
          audit_status:-1,
          create_time:"",
          

        },

        open_add:false,
        open_edit:false,
        service_id:"",
        service_info_id:"",
   
      };
    },
    props: [],
    created() {


      /*获取列表*/
      this.getTableList();
    },
    methods: {
        /*关闭弹窗*/
        dialogFormVisibled(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisibled("error")
    },

  
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Params.service_id = self.service_id
        ServiceApi.listInfo(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            for(var i=0;i<self.tableData.length;i++){
                self.tableData[i].is_declare =  self.tableData[i].is_declare ==1?true:false;
            }
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.service_info_id = row.service_info_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            ServiceApi.delInfo(
              {
                service_info_id: row.service_info_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      passClick(item){//通过审核
      var self = this;
      var Params = {
        service_info_id:item.service_info_id,
        audit_status:1
      }
      ServiceApi.passCanel(Params, true)
        .then(data => {
          console.log(data)
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {


        });

    },
    async nopassClick(item){//不通过审核
      var self = this;
      const reject_val = await this.promptInput('请输入不通过的原图', '请输入2-4个汉字');
      
      var Params = {
        service_info_id:item.service_info_id,
        audit_status:2,
        reject_val:reject_val
      }
      if(reject_val !="取消"){
        ServiceApi.passCanel(Params, true)
        .then(data => {
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {});
      }

    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: validation,
        });
        return value.trim();
      } catch(e) {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
        return "取消";
      }
    },
    
    isDefaultChange(row){
      let self = this
      self.$confirm('是否申报?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(row.is_declare);
        let is_declare = 1;
        if(row.is_declare){
          is_declare = 1;
        }else{
          is_declare = 0;
        }
        self.loading = true;
        ServiceApi.setDeclare({service_info_id: row.service_info_id,is_declare:is_declare}, true).then(data => {
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '快捷申报成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        });
      }).catch(() => {
        row.is_default = !row.is_default
      })

       

      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/service/index/declare/index1.vue